const CONSENT_COOKIE_NAME = 'cookieyes-consent'
const ANALYTICS_CATEGORY = 'analytics'
const CONSENT_GRANTED = 'yes'
const GTM_SCRIPT_ID = 'gtm-script'
const CONSENT_POLL_INTERVAL_MS = 1000

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

const getCookieValue = (name: string) => {
  const prefix = `${name}=`

  for (const segment of document.cookie.split(';')) {
    const normalizedSegment = segment.trim()

    if (normalizedSegment.startsWith(prefix)) {
      return normalizedSegment.slice(prefix.length)
    }
  }

  return ''
}

const parseConsentCookie = () => {
  try {
    const consentCookie = decodeURIComponent(getCookieValue(CONSENT_COOKIE_NAME))

    return consentCookie.split(',').reduce<Record<string, string>>((consentState, entry) => {
      if (!entry) {
        return consentState
      }

      const [key, ...valueParts] = entry.split(':')

      if (!key || valueParts.length === 0) {
        return consentState
      }

      consentState[key] = valueParts.join(':')
      return consentState
    }, {})
  } catch {
    return {}
  }
}

const hasAnalyticsConsent = () => parseConsentCookie()[ANALYTICS_CATEGORY] === CONSENT_GRANTED

const injectGtm = (containerId: string) => {
  if (document.getElementById(GTM_SCRIPT_ID)) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js'
  })

  const script = document.createElement('script')
  script.id = GTM_SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`

  document.head.appendChild(script)
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const containerId = (config.public as { gtm?: { containerId?: string } }).gtm?.containerId ?? ''

  if (!containerId) {
    return
  }

  const startIfConsented = () => {
    if (!hasAnalyticsConsent()) {
      return
    }

    injectGtm(containerId)
  }

  startIfConsented()

  const consentPollId = window.setInterval(() => {
    startIfConsented()

    if (document.getElementById(GTM_SCRIPT_ID)) {
      window.clearInterval(consentPollId)
    }
  }, CONSENT_POLL_INTERVAL_MS)

  window.addEventListener('beforeunload', () => {
    window.clearInterval(consentPollId)
  }, { once: true })
})
